import {
	isVueRoute,
	isHybridEnvironment,
	isHybridLocalEnvironment,
} from "@/common/functions";

export default {
	methods: {
		pushZebraNavigation(to) {
			let toAsHref = to;
			if (typeof toAsHref !== "string") {
				toAsHref = this.$router.resolve(to).href;
			}

			if (
				typeof window === "object" &&
				!isVueRoute(toAsHref) &&
				isHybridEnvironment(window.location.origin)
			) {
				return window.location.assign(toAsHref);
			} else if (
				typeof window === "object" &&
				!isVueRoute(toAsHref) &&
				isHybridLocalEnvironment(window.location.origin)
			) {
				return window?.location.assign(
					`http://wordfinder-local.yourdictionary.com:8083${toAsHref}`
				);
			}

			this.$router.push(to);
		},
	},
};
